import React, {useRef, useState} from 'react';
import {OneRepChartPoint} from 'components/dashboard/manager/nine-box/one-rep-chart/OneRepData.utils';
import {AvatarPoint} from 'charts/components/elements/AvatarPoint';
import {FixedLabelPopper} from 'components/dashboard/manager/nine-box/avatar/FixedLabelPopper';
import {AvatarPointPopper} from 'components/dashboard/manager/nine-box/avatar/AvatarPointPopper';
import {RepInfoPopup} from 'components/dashboard/manager/nine-box/one-rep-chart/RepInfoPopup';
import {RepChartPoint} from '@store/@types/metric';
import {Moment} from 'moment';
import Text from '@material-ui/core/Typography';
import {DateFormat} from 'utils/datetime/DateFormat';

interface AvatarTooltipWrapperProps {
  oneRepData?: OneRepChartPoint;
  multiRepData: RepChartPoint;
  onCreatePlan: () => void;
  startDate: Moment;
  endDate: Moment;
  setCrosshair: (show: boolean) => void;

  onClick?: (event?: any) => void;
  size?: number;
  highlight?: boolean;
  image?: string;
}

/**
 * Used in OneRep and MultiRep chart. Wraps the Avatar Point component with crosshairs and popups
 */
export const AvatarTooltipWrapper: React.FC<AvatarTooltipWrapperProps> = ({
  highlight,
  image,
  multiRepData,
  oneRepData,
  onCreatePlan,
  startDate,
  endDate,
  onClick,
  setCrosshair,
}) => {
  const anchorEl = useRef(null);
  const [hoverOpen, setHoverOpen] = useState(false);
  const [labelOpen, setLabelOpen] = useState(false);
  const timer = useRef<any>();
  const rep = multiRepData.rep;
  const metricInfo = multiRepData.metricInfo;
  const coordinates = oneRepData ?? multiRepData.coordinate;

  const clearHoverTimer = () => clearTimeout(timer.current);

  const handleShowPopper = () => {
    clearHoverTimer();
    setHoverOpen(true);
    setLabelOpen(true);
    setCrosshair(true);
  };

  const handleHidePopper = () => {
    clearHoverTimer();
    setCrosshair(false);
    timer.current = setTimeout(() => {
      setHoverOpen(false);
    }, 200);
  };

  return (
    <>
      <AvatarPoint
        user={rep}
        coordinate={coordinates}
        mainRef={anchorEl}
        onMouseEnter={handleShowPopper}
        onMouseLeave={handleHidePopper}
        image={image}
        highlight={highlight}
        onClick={onClick}
      />
      <AvatarPointPopper
        onMouseEnter={clearHoverTimer}
        onMouseLeave={handleHidePopper}
        open={hoverOpen}
        anchorEl={anchorEl}>
        <RepInfoPopup
          rep={rep}
          repMetricInfo={metricInfo}
          onCreatePlan={onCreatePlan}
          endDate={endDate}
          startDate={startDate}
          onClose={() => setHoverOpen(false)}
          showClickBlurb={onClick ? true : false}
        />
      </AvatarPointPopper>
      {oneRepData && (
        <FixedLabelPopper
          anchorEl={anchorEl}
          open={labelOpen}
          placement={image ? 'right' : 'bottom'}
          setLabelOpen={setLabelOpen}>
          <Text>{oneRepData.date.format(DateFormat.M_DD_YY)}</Text>
        </FixedLabelPopper>
      )}
    </>
  );
};
